// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => `
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;
